import TopHead from "./components/top_head";
import Navbar from "./components/top_nav";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import Down_nav from "./components/bottom_nav";
import AbstractPage from "./pages/abstract";
import IntroductionPage from "./pages/intro";
import Application_of_GIS_Page from "./pages/application_of_gis";
import LCAPage from "./pages/life_cycle_assessment";
import ConclusionPage from "./pages/conclusion";
import ReferencesPage from "./pages/references";
import AcknowledgementPage from "./pages/acknowledgement";
import CitationPage from "./pages/cite";

function App() {
  return (
    <div
      style={{
        backgroundImage: 'url("images/gis9.avif")',
        backgroundSize: "cover",
      }}
    >
      <Router basename="energy/paper/Geographical_Information_System">
        <TopHead />
        <Navbar />
        <Down_nav />
        <Routes>
          <Route path="/" element={<AbstractPage />} />
          <Route path="/abstract" element={<AbstractPage />} />
          <Route path="/intro" element={<IntroductionPage />} />
          <Route
            path="/application_of_gis"
            element={<Application_of_GIS_Page />}
          />
          <Route path="/life_cycle_assessment" element={<LCAPage />} />
          <Route path="/conclusion" element={<ConclusionPage />} />
          <Route path="/acknowledgement" element={<AcknowledgementPage />} />
          <Route path="/references" element={<ReferencesPage />} />
          <Route path="/cite" element={<CitationPage />} />
        </Routes>
      </Router>
    </div>
  );
}
export default App;
